import { Icon, Text, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
export const BarWarningLimitReached = () => {
  return (
    <HStack
      bg={Utils.ColorToken.WithOpacity('feedback.attention.lightest', 0.4)}
      px={Spacing['inline.xxxs']}
      py={Spacing['inline.nano']}
      my={Spacing['inline.nano']}
      space={Spacing['inline.quarck']}
      alignItems="center"
      borderRadius={BoxRadius.sm}>
      <Icon name="Warning" size="xxxs" color={Color['feedback.attention.default']} />
      <Text variant="semibold" fontSize={Typography['fontsize.md']} color={Color['neutral.black']}>
        Atenção:{' '}
      </Text>
      <Text variant="regular" fontSize={Typography['fontsize.md']} color={Color['neutral.black']}>
        Limite atingido, máximo de 20 itens por seleção.
      </Text>
    </HStack>
  );
};
